import { IAbExperiment } from '../../types/abUseExperiments';

export enum EAbUseExperimentsActions {
  PushExperiments = 'abUseExperiments/pushExperiments',
}

export interface IPushExperimentsAction {
  type: EAbUseExperimentsActions.PushExperiments;
  payload: IAbExperiment[];
}

export function pushExperiments(payload: IAbExperiment[]): IPushExperimentsAction {
  return {
    type: EAbUseExperimentsActions.PushExperiments,
    payload,
  };
}

export type TAbUseExperimentsActions = IPushExperimentsAction;
